import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import {
    LotFetchedFailedAction,
    LotFetchedSuccessfulAction,
    SelectedLotUIActions,
    SelectLotAction,
} from './selected-lot.actions';
import {
    AuctionCatalogsService as AuctionsService,
    GetLotById200Response,
} from '@viewbid/ts-angular-client';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class SelectedLotEffects {
    lotSelected$ = createEffect(() => {
        const selected$: Observable<string> = this.actions$.pipe(
            ofType(SelectedLotUIActions.SelectLotAction),
            map((action: SelectLotAction) => action.props.lotId),
        );

        return selected$.pipe(
            switchMap((lotId: string) => {
                return this.auctionService.getLotById(lotId).pipe(
                    map((result: GetLotById200Response) => {
                        return new LotFetchedSuccessfulAction({
                            result: result.data,
                        });
                    }),
                    catchError((_error: HttpErrorResponse) => {
                        const errorCode: string = _error?.error?.errorCode;

                        return of(new LotFetchedFailedAction({ errorCode }));
                    }),
                );
            }),
        );
    });

    constructor(
        private actions$: Actions,
        private auctionService: AuctionsService,
    ) {}
}
